module.exports = __webpack_public_path__ + "img/jersey.af6b1871.png";